import React from 'react'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiCpu } = FiIcons

const AIInsightCard = ({ title, insights, loading, icon }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="bg-purple-100 p-2 rounded-lg">
          <SafeIcon icon={icon || FiCpu} className="h-5 w-5 text-purple-600" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-purple-600"></div>
          <span className="ml-2 text-gray-600">Generating insights...</span>
        </div>
      ) : insights ? (
        <div className="space-y-4">
          {insights.error ? (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-red-600">{insights.error}</p>
              {insights.fallback && (
                <div className="mt-3 text-gray-600">
                  <p className="font-medium">Basic Analysis:</p>
                  <p>{insights.fallback.summary}</p>
                </div>
              )}
            </div>
          ) : (
            <>
              {insights.summary && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <p className="text-blue-800 font-medium">Summary</p>
                  <p className="text-blue-700 mt-1">{insights.summary}</p>
                </div>
              )}
              
              {insights.insights && Array.isArray(insights.insights) && (
                <div className="space-y-3">
                  {insights.insights.map((insight, index) => (
                    <div key={index} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
                      <div className="bg-purple-100 p-1 rounded-full mt-1">
                        <SafeIcon icon={FiCpu} className="h-3 w-3 text-purple-600" />
                      </div>
                      <p className="text-gray-700 text-sm">{insight}</p>
                    </div>
                  ))}
                </div>
              )}
              
              {typeof insights === 'string' && (
                <div className="prose prose-sm max-w-none text-gray-700">
                  <p>{insights}</p>
                </div>
              )}
            </>
          )}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <p>No insights available yet</p>
          <p className="text-sm mt-1">Click "Refresh Insights" to generate analysis</p>
        </div>
      )}
    </div>
  )
}

export default AIInsightCard